import {module} from 'modujs';
import * as CookieConsent from 'vanilla-cookieconsent';

export default class extends module {
    constructor(m) {
        super(m);

        this.$el = this.el;
        var opts = this.$el.getAttribute('data-cookie-consent-options');

        try {
            this.cookieConfig = JSON.parse(opts);
        } catch (e) {
            console.warn(e.message);
        }

        this.events = {
            click: {
                hide: 'hideModal',
                'show-preferences': 'showPreferences'
            },
        };

        this.cookieConfig.categories = this.prepareCategories(this.cookieConfig.categories);

        CookieConsent.run(this.cookieConfig);
    }

    prepareCategories(categories) {
        for (const [categoryName, categoryData] of Object.entries(categories)) {
            if (
                categoryData?.autoClear?.cookies &&
                Array.isArray(categoryData.autoClear.cookies) &&
                categoryData.autoClear.cookies.length > 0
            ) {
                categoryData.autoClear.cookies.map((cookie) => {
                    if (
                        cookie?.name &&
                        typeof cookie.name === 'string'
                    ) {
                        const found = cookie.name.match(/^\/(.+)\/([a-z]+)?$/);
                        if (found) {
                            cookie.name = new RegExp(found[1], found[2]);
                        }
                    }

                    return cookie;
                });

                categories[categoryName].autoClear.cookies = categoryData.autoClear.cookies;
            }
        }

        return categories;
    }

    showPreferences(e) {
        e.preventDefault();
        e.stopPropagation();
        this.call('close', null, 'Menu')
        CookieConsent.showPreferences();
    }

    hideModal() {
        CookieConsent.hidePreferences();
        CookieConsent.hide();
    }
}
